import { updateValueColumns } from "actions/columns/updateValueColumns";
import classNames from "classnames";
import React from "react";
import { useDispatch } from "react-redux";
import {
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import styled from "styled-components";
import { PERCENT_FORMAT } from "constants/common";
import { isNumber } from "lodash";
import useDrawFocusBorder from "hooks/useDrawFocusBorder";

const REGEX_NUMBER = /^\d*,?\d*$/;

export const formatNumber = (value) => {
  if (value === 0) return "";
  const num = value?.toString()?.split(".").join("");
  return num;
};

const ColumnNumber = ({
  value: defaultValue = "",
  position_format = 1,
  taskId = "",
  format = "",
  idType,
  dataType,
  handleReload = () => {},
  disabled,
  valueOriginal,
  canEdit,
  ...props
}) => {
  const [value, setValue] = React.useState(defaultValue);
  const [isFocus, setIsFocus] = React.useState(false);
  const refValue = React.useRef(defaultValue);
  const refOldValue = React.useRef(defaultValue);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  useDrawFocusBorder(anchorEl);

  React.useEffect(() => {
    if (isFocus && dataType === 2) {
      const formattedNum = formatNumber(value || defaultValue);
      setValue(formattedNum);
    } else {
      setValue(defaultValue);
    }
  }, [defaultValue, isFocus]);

  const _handleChange = (e) => {
    setValue(e.target.value);
    if (!isFocus) refValue.current = e.target.value;
  };

  const _handleKeyUp = (e) => {
    if (e.key === "Enter") {
      setIsFocus(false);
      e.target.blur();
    }
  };

  const validPercent = (val) => {
    return format === PERCENT_FORMAT
      ? val > 100 || val < 0
        ? false
        : true
      : true;
  };

  const validateNum = (val) => {
    // return if dataType = 1 : text
    if (dataType === 1) return true;

    if (!isNumber(Number(val))) {
      return false;
    }

    if (!val.match(REGEX_NUMBER)) {
      return false;
    }
    return validPercent(val);
  };

  const _handleBlur = (e) => {
    setIsFocus(false);
    e.target.closest(".td")?.classList?.remove("focus");
    if (isNaN(e.target.value) && dataType === 2) {
      setValue(refValue.current);
    }
    const val = e.target.value;

    const validateVal = validateNum(val);

    if (!validateVal) {
      SnackbarEmitter(SNACKBAR_VARIANT.ERROR, "Không đúng yêu cầu");
      setValue(defaultValue);
      return;
    }

    if (val != formatNumber(defaultValue)) {
      dispatch(
        updateValueColumns(
          {
            task_id: taskId,
            field_id: idType,
            data_type: dataType,
            value: val,
          },
          (is_sync_data) => {
            refOldValue.current = val;
            refValue.current = val;
            setValue(val);
            handleReload();
            // if (is_sync_data) {
            //   handleReload();
            // }
          },
          () => {
            setValue(refOldValue.current);
            handleReload();
          }
        )
      );
    }
  };

  const _handleFocus = (e) => {
    e.target.closest(".td").classList.add("focus");
    if (!canEdit) return;
    setIsFocus(true);
  };

  const finalValue = () => {
    if (!isFocus) {
      const showText = `${position_format === 1 ? format : ""} ${value} ${
        position_format === 2 ? format : ""
      }`;
      return value?.toString() !== "0" ? showText : "";
    }
    return value;
  };

  const handleClickCell = (event) => {
    setAnchorEl(event.target.closest(".td"));
  };
  // number col
  return (
    <InputColumn
      className={classNames({
        canHide: !String(value).length,
        textRight: position_format === 2,
      })}
      onChange={_handleChange}
      onBlur={_handleBlur}
      onKeyUp={_handleKeyUp}
      onFocus={_handleFocus}
      placeholder="—"
      value={value ? finalValue() : ""}
      disabled={disabled}
      onClick={handleClickCell}
    />
  );
};

const InputColumn = styled.input`
  height: 100 %;
  border: 0;
  outline: 0;
  border-radius: 0;
  border-width: 0;
  box-sizing: border-box;
  background-color: transparent;
  width: 100%;

  &.canHide {
    visibility: hidden;
  }
  &.textRight {
    text-align: right;
  }
`;

export default React.memo(ColumnNumber);
